import { apiFetch } from '@ami/react/core';

const _baseEndPoint = 'customer-approvals-lookup';

const customerApprovalDocumentLookupServices = {
  getDownloadPdf: (customerApprovalId, id) => {
    return apiFetch(
      `${_baseEndPoint}/${customerApprovalId}/approval-documents/${id}/pdf`,
      'GET',
      null,
      null,
      true
    );
  },
  getDownloadUrl: (customerApprovalId, id) => {
    return apiFetch(
      `${_baseEndPoint}/${customerApprovalId}/approval-documents/${id}`,
      'GET',
      null,
      null,
      true
    );
  },
  getDownloadRevisionUrl: (customerApprovalId, id, revision) => {
    return apiFetch(
      `${_baseEndPoint}/${customerApprovalId}/approval-documents/${id}/revision/${revision}`,
      'GET',
      null,
      null,
      true
    );
  },
};
export { customerApprovalDocumentLookupServices };
